<template>
  <div class="content">
    <NavBar :navBlock='navBlock' :navtitle='navtitle'></NavBar>
    <div class="paddingContent">

        <!-- <div style="width:100%;padding-right:0.2rem;margin-bottom:0.2rem;" >

          <div style="margin-bottom:0.1rem;display:flex;align-items: center;justify-content: space-between;">

            <p>公告</p>

            <div v-if="editNotice" class="btn" style="width:0.6rem;" @mousedown="completeBillBoard()">完成</div>

            <div v-else class="btn" style="width:0.6rem;" @click="editNotice=true">编辑</div>

          </div>
          
          <el-input
            ref="notice"
            @blur="blurEvent()"
            v-model="billBoard"
            :disabled="!editNotice"
            type="textarea"
            maxlength='100'
            show-word-limit
            :autosize="{ minRows: 2}"
            placeholder="請輸入公告">

          </el-input>
        </div> -->



        <div class="ListMenu">
          <el-form ref="form" :model="listMenuForm" class="searchForm">
            <el-form-item label="話題名稱" class="">
              <el-input v-model="listMenuForm.subjectName"></el-input>
            </el-form-item>

            <el-form-item label="話題類型">
              <el-select v-model="listMenuForm.subjectType" placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                <el-option label="热门" value="1"></el-option>
                <el-option label="普通" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="開始時間："  class="searchItem ">
            <el-date-picker v-model="listMenuForm.startTime" type="datetime"  placeholder="選擇時間"></el-date-picker>
          </el-form-item>

          <el-form-item label="結束時間："  class="searchItem hidden-md-and-down">
            <el-date-picker v-model="listMenuForm.endTime" type="datetime" placeholder="選擇時間"></el-date-picker>
          </el-form-item>
          </el-form>
      </div>
      <div class="ListMenu">
        <el-form ref="form" :model="listMenuForm" class="searchForm">
          <el-form-item label="結束時間："  class="searchItem hidden-lg-and-up">
            <el-date-picker v-model="listMenuForm.endTime" type="datetime" placeholder="選擇時間"></el-date-picker>
          </el-form-item>
        </el-form>
        
      </div>
      
      <div class="MenuBtnWrap">
        <div class="btn" @click="search()">查詢</div>
        <div class="btn borderBtn" @click="reset()">重置</div>
        <div class="btn" @click="$router.push('/addSubject')">新增話題</div>
        <div class="btn" @click="$router.push('/editBillBoard')">編輯公告</div>

      </div>
      <div class="tableWrap">
        <el-table height='660px' stripe :data="subjectList" style="width:100%;">
          <template slot="empty">
            <div class="no-data-container">
              <img src="@/assets/images/common/no_data.png" alt="暂无数据" :style="{width:'244px',height:'139px'}">
            </div>
          </template>
          <el-table-column
            v-for="(item, index) in subjectTable" :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width">
          </el-table-column>
          <el-table-column
            label="操作"
            width='140'
            fixed="right">
            <template slot-scope="scope">
              <el-button @click="toEditSubject(scope.row.id)" type="text" >編輯</el-button>
              <el-button @click="delClick(scope.row.id)" type="text" >刪除</el-button>
              <el-button v-if="scope.row.state == '熱門'" @click="editHot(scope.row.id,scope.row.state)" type="text" >撤銷</el-button>
              <el-button v-if="scope.row.state == '普通'"  @click="editHot(scope.row.id,scope.row.state)" type="text" >熱門</el-button>


            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination class="paging fr"
          hide-on-single-page
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          :pager-count='5'
          layout="prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <div v-if="delFlag" tabindex="-1" role="dialog" aria-modal="true" aria-label="提示信息" class="el-message-box__wrapper" style="z-index: 2005;background:rgba(0,0,0,0.2);">

      <div class="el-message-box el-message-box--center">

        <div class="el-message-box__header">
          <div class="el-message-box__title">
            <span>提示信息</span>
          </div>
          <button @click="closeDel()" type="button" aria-label="Close" class="el-message-box__headerbtn">
            <i class="el-message-box__close el-icon-close"></i>
          </button>
        </div>
        
        <div class="el-message-box__content" style="margin:0.4rem 0;">
          <div class="el-message-box__message"><p>是否刪除該話題?</p>
        </div>

      </div>

      <div class="del__btns">
        <button @click="toggleDelType(1)" type="button" :class="delType == 1 ? 'delbtn delbtnActive' : 'delbtn'">
          <span>保留帖子话题</span>
        </button>
        <button @click="toggleDelType(0)" type="button" :class="delType == 0 ? 'delbtn delbtnActive' : 'delbtn'">
          <span>删除帖子话题</span>
        </button>
      </div>

      <div class="el-message-box__btns" style="margin-top:0.4rem;">
        <button @click="delSubject()" type="button" style="background: #6c3dea;color: #fff;">
          <span>确定</span>
        </button>
      </div>

    </div>
  </div>

    <DiaMess v-if="dialogVisible"></DiaMess>

  </div>
</template>

<script>
import NavBar from '@/components/navBar';
import DiaMess from '@/components/dialog';
export default {
  data () {
    return {
      navBlock:'社區',
      navtitle:'話題列表',
      listMenuForm:{
        subjectName: '',
        subjectType: '',
        startTime:'',
        endTime:''

      },
      subjectList:[],
      subjectTable: [
        {
          prop: 'label',
          label: '話題名稱',
          width: ''
        }, {
          prop: 'createDate',
          label: '創建時間',
          width: '250'
        }, {
          prop: 'state',
          label: '話題類型',
          width: '150'
        }, {
          prop: 'rank',
          label: '排序',
          width: '200'
        }
      ],
      currentPage: 1, // 分页
      total: 0,
      dialogVisible: false,
      delType: 1,
      delFlag: false,
      delSubId: '',
      billBoard:'',
      flag:false,
    }
  },
  created(){
    this.getSubjectList();
  },
  activated(){
    if (this.currentPage === 1){
      this.getSubjectList();
    }
  },
  destroyed(){
    this.$message.closeAll();
  },
  methods:{
    // 获取话题列表信息
    getSubjectList(){
      let _this = this;
      let param ={
        page: _this.currentPage,
        size: 10,
        state: _this.listMenuForm.subjectType == '' ? '' : Number(_this.listMenuForm.subjectType),
        title: _this.listMenuForm.subjectName,
        startTime: (_this.listMenuForm.startTime === ''|| _this.listMenuForm.startTime === null)  ? null  : _this.$formatDate(_this.listMenuForm.startTime),
        endTime: (_this.listMenuForm.endTime === '' || _this.listMenuForm.endTime === null) ? null : _this.$formatDate(_this.listMenuForm.endTime),
      }
      _this.$post('/request/community/topicList', param, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.code === '00000') {
            // console.log(res.data)
            res.data.list.forEach(v => {
                if(v.state == 0) {
                  v.state = "普通"
                } else if(v.state == 1) {
                  v.state = "熱門"
                }
            });
            _this.subjectList = res.data.list;
            _this.total = res.data.allRow;
          } else {
            _this.$propMessage(res.message, 'error');
          };
        });
    },
    
    //编辑失焦事件
    // blurEvent(){
    //   let _this = this;
                
    //   if(_this.flag == false){
    //       _this.$confirm('是否放弃编辑公告內容?', '提示信息', {
    //         confirmButtonText: '確認',
    //         cancelButtonText: '取消',
    //         center: true
    //       }).then(() => {
    //         _this.billBoard = _this.originBillBoard;
    //       }).catch(() => {
    //         _this.$refs['notice'].focus()
    //         console.log('继续编辑')
    //       });
    //   }
      
      
    // },
    
    closeDel(){
      this.delFlag = false;
      this.delType = 1;
    },
    // 分页
    handleCurrentChange (val) {
      this.currentPage = val;
      this.getSubjectList();
    },
    //删除点击
    delClick(id){
      let _this = this;
      _this.delFlag = true; 
      _this.delSubId = id;                                                                                                      
    },
    //撤銷/熱門
    editHot(id,state){
      let _this = this
      let tips = state == '普通' ? '是否設置為熱門話題？' : '是否撤銷熱門話題？';
      let status = state == '普通' ? 1 : 0;//话题修改以后的状态
      this.$confirm(tips, '提示信息', {
          confirmButtonText: '確認',
          cancelButtonText: '取消',
          center: true,
          closeOnClickModal: false
        }).then(()=> {
          _this.$get(`/request/community/updateTopicState?id=${id}&state=${status}`)
            .then((res) => {
              _this.dialogVisible = true;
              if (res.code==='00000') {
                _this.getSubjectList();
                _this.$propMessage('設置成功', 'success',
                  function(){
                    _this.dialogVisible = false;
                  });

              } else {
                _this.$propMessage(res.message, 'error',
                  function(){
                    _this.dialogVisible = false;
                  });
              };
            })
      })
    },
    // 删除活动
    delSubject(){
      let _this = this;
      // 确认删除的回调
      _this.$get(`/request/community/delTopic?id=${_this.delSubId}&status=${_this.delType}`, {}, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          _this.dialogVisible  = true;
          if(res.code === '00000'){
            _this.delFlag = false;
            _this.delType = 1;

            _this.$propMessage('刪除成功，請稍候', 'success',
              function(){
              _this.dialogVisible = false;
              _this.currentPage = 1;
              _this.getSubjectList();
              });

          } else {
            _this.$propMessage(res.message, 'error',
              function(){
              _this.dialogVisible = false;
              });
          };
      });
    },
    // 进入修改页面状态
    toEditSubject (id,) {
        this.$router.push(`/editSubject?id=${id}`);
    },
    //切换删除类型
    toggleDelType(type){
      this.delType = type;
    },
    // 查詢
    search(){
      let _this = this;
      if (_this.listMenuForm.subjectName === '' && _this.listMenuForm.subjectType === '' && _this.listMenuForm.startTime ==='' && _this.listMenuForm.endTime === '') {
        _this.dialogVisible = true;
        _this.$propMessage('請輸入至少一個搜索條件','error',function(){
          _this.dialogVisible = false;
        });
        return false;
      }
      _this.currentPage = 1;
      _this.getSubjectList();
    },
    //重置查詢條件
    reset(){
      this.listMenuForm = {
        subjectName: '',
        subjectType: '0',
        startTime: '',
        endTime: '',
      }
      this.currentPage = 1;
      this.getSubjectList()
    }
  },
  components: {
    NavBar,
    DiaMess,
  }
};
</script>

<style lang="less">
  .del__btns{
    padding: 5px 15px 0;
    text-align: center;
  }
  .del__btns button:nth-child(2) {
    margin-left: 0.6rem;
  }
  .delbtn{
    width: 1.28rem;
    height: 0.4rem;
    background: #6c3dea;
    border: none;
    color: #fff;
    border-radius: 4px;
    background: #fff;
    color: #ada5a5;
    border: 1px solid #ada5a5;
  }
  .delbtn:hover,.delbtnActive{
    background: #fff;
    color: #6c3dea;
    border: 1px solid #6c3dea;
  }

  @media screen and (min-width: 769px) {
    .ListMenu{
        display: flex;
        justify-content: space-between;
        // align-items: center;
        .searchForm{
          flex: 1;
          display: flex;
          justify-content: flex-start;
        }
        .MenuBtnWrap{
          flex: 1;
        }
      }
    }
</style>




// WEBPACK FOOTER //
// src/pages/community/subjectList.vue